// src/components/DiscussionInfoModal.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/styles.css';

function DiscussionInfoModal({ discussion, API_URL, token }) {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const formatDate = (date) =>
    new Date(date).toLocaleDateString(i18n.language, {
      day: 'numeric', month: 'short', year: 'numeric'
    });

  const initials = (name = '') =>
    name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  return (

    <>

      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', display: 'flex', alignItems: 'center' }}
        title="Infos sur la discussion"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--text-muted, #1976d2)">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
        </svg>
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: '1rem',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'var(--card-bg, #fff)', borderRadius: 16,
              width: '100%', maxWidth: 400, overflow: 'hidden',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            }}
          >
            {/* Header */}
            <div style={{ background: '#1565c0', padding: '1.25rem', position: 'relative' }}>
              <button
                onClick={() => setOpen(false)}
                style={{
                  position: 'absolute', top: 10, right: 12,
                  background: 'rgba(255,255,255,0.15)', border: 'none',
                  borderRadius: '50%', width: 28, height: 28,
                  cursor: 'pointer', color: 'white', fontSize: 18,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >×</button>
              <p style={{ margin: '0 0 8px', fontSize: 11, color: 'rgba(255,255,255,0.65)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                {t('diffusion.public')}
              </p>
              <p style={{ margin: 0, fontSize: 17, fontWeight: 500, color: '#fff', lineHeight: 1.3 }}>
                {discussion.title}
              </p>
            </div>

            {/* Body */}
            <div style={{ padding: '1.25rem', background:'transparent' }}>

              {/* Créateur */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '0.5px solid #eee' }}>
                {discussion.creator?.profileImage ? (
                  <img
                    src={`${API_URL}/api/decryptedFile/decrypted-cloudinary-file/${discussion.creator._id}?token=${token}&type=image&thumb=true&profile=true`}
                    alt=""
                    style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                  />
                ) : (
                  <div style={{
                    width: 36, height: 36, borderRadius: '50%',
                    background: '#e3f2fd', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: 14, fontWeight: 500,
                    color: '#1565c0', flexShrink: 0,
                  }}>
                    {initials(discussion.creator?.username)}
                  </div>
                )}
                <div>
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 500 }}>{discussion.creator?.username}</p>
                  <p style={{ margin: 0, fontSize: 12, color: '#888' }}>Admin</p>
                </div>
              </div>

              {/* Description */}
              {discussion.description && (
                <p style={{ margin: '0 0 1rem', fontSize: 13, color: '#555', lineHeight: 1.6 }}>
                  {discussion.description}
                </p>
              )}

              {/* Stats */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: '1rem' }}>
                <div style={{ background: 'var(--input-bg)', borderRadius: 8, padding: '10px 12px' }}>
                  <p style={{ margin: '0 0 2px', fontSize: 11, color: '#888' }}>{t('diffusion.abonnes')}</p>
                  <p style={{ margin: 0, fontSize: 18, fontWeight: 500 }}>{discussion.participants?.length ?? 0}</p>
                </div>
                <div style={{ background: 'var(--input-bg)', borderRadius: 8, padding: '10px 12px' }}>
                  <p style={{ margin: '0 0 2px', fontSize: 11, color: '#888' }}>{t('diffusion.date')}</p>
                  <p style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>{formatDate(discussion.createdAt)}</p>
                </div>
              </div>

              {/* Badges */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', background: 'var(--input-bg)', borderRadius: 8 }}>
                  <span style={{ fontSize: 13, color: '#555' }}>💬 {t('diffusion.comments')}</span>
                  <span style={{
                    fontSize: 12, fontWeight: 500, padding: '2px 8px', borderRadius: 20,
                    background: discussion.allowComments ? '#e8f5e9' : '#fce4ec',
                    color: discussion.allowComments ? '#2e7d32' : '#c62828',
                  }}>
                    {discussion.allowComments ? t('diffusion.oui') : t('diffusion.non')}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', background: 'var(--input-bg)', borderRadius: 8 }}>
                  <span style={{ fontSize: 13, color: '#555' }}>🌐 {t('diffusion.visibilite')}</span>
                  <span style={{ fontSize: 12, fontWeight: 500, padding: '2px 8px', borderRadius: 20, background: '#e3f2fd', color: '#1565c0' }}>
                    {discussion.visibility === 'contacts' ? t('diffusion.visibility_admin'): t('diffusion.visibility_everyone')}
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DiscussionInfoModal;